import * as React from 'react';
import * as problems from './problems.module.scss';
export const Problems = () => {
  return (
    <section id={'learn-more'}>
      <div className={'container'}>
        <h2 className={problems.problems__title}>Это мешает ребенку расти как личность</h2>
        <ul className={problems.problems__list}>
          <li className={problems.problems__item}>
            <div className={`${problems.problems__img} ${problems.problems__imgOne}`}></div>
            <div className={problems.problems__text}>
              <h3 className={problems.problems__name}>Cамооценка и уверенность в себе снижаются</h3>
              <p className={problems.problems__description}>
                Низкие оценки и недовольные учителя как бы говорят: «Ты не сможешь». Ребенок начинает сомневаться в
                себе, становится нерешительным. Неуверенность порождает всё новые неудачи, которые, в свою очередь,
                мешают стать увереннее.
              </p>
            </div>
          </li>
          <li className={problems.problems__item}>
            <div className={`${problems.problems__img} ${problems.problems__imgTwo}`}></div>
            <div className={problems.problems__text}>
              <h3 className={problems.problems__name}>Появляется стойкое отвращение к любому обучению</h3>
              <p className={problems.problems__description}>
                Учеба ассоциируется с тяжелейшим трудом. Часто такие дети, повзрослев, готовы десятилетиями работать на
                рутинной бесперспективной должности, лишь бы больше никогда не учиться.
              </p>
            </div>
          </li>
          <li className={problems.problems__item}>
            <div className={`${problems.problems__img} ${problems.problems__imgThree}`}></div>
            <div className={problems.problems__text}>
              <h3 className={problems.problems__name}>Начинаются проблемы с ответственностью</h3>
              <p className={problems.problems__description}>
                Выполняя обязательства из-под палки, ребенок рано или поздно придет к выводу, что быть ответственным —
                тяжело и неприятно. Так безответственность перерастёт в бунтарство.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};
